import { ICarouselItem } from "../../components/Carousel/Carousel";
import { useAsyncLoadImage } from "../../utils/hooks/useAsyncLoadImage";

interface IRecommendedArticlesSlideProps extends ICarouselItem {
  card: ArticleResponse;
}

export const RecommendedArticlesSlide = ({
  card,
  dragging,
  onClick,
}: IRecommendedArticlesSlideProps) => {
  const imageUrl = useAsyncLoadImage(card.cover_image);

  return (
    <div
      className="card card-left-orient cards-slider-left-orient__card"
      onClick={() => !dragging && onClick?.()}
    >
      <div className="card__media">
        <span
          className="card__media-pic"
          style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}
        >
          {!imageUrl && <div className="skeleton"></div>}
        </span>
      </div>
      <div className="card__body">
        <div className="card__title">{card.article_name}</div>
      </div>
    </div>
  );
};
